import Image from 'app/Components/Shared/Image/image';
import React,{useState} from "react";
import purpleCheckMark from './Assets/Svg/purpleCheckMark.svg';

const CheckboxWithText = ({text, callback}) => {
  const [isChecked, setIsChecked] = useState(false);

  const handleToggle = () => {
    const newValue = !isChecked;
    setIsChecked(newValue);
    if(callback){
      callback(newValue);
    }
  }

  return (
    <div className="checkbox-with-text">
      <div className="checkbox" id="checkbox" checked={isChecked} onClick={handleToggle}>
       {isChecked && <Image className="checkmark" src={purpleCheckMark} />}
      </div>
      <label htmlFor='checkbox' onClick={handleToggle} className='text'>{text}</label>
    </div>
  );
}
export default CheckboxWithText;
